<template>
  <Popover ref="ncrPopover" :showHeader="true" headerTitle="Non Chargeable Rework">
    <div class="order-item-popover-content ncr-details-popover-area">
      <div v-if="itemData.ncrRequestReason" class="mt-1 mb-2">
        <strong>NCR Request Reason</strong>
        <div v-html="convertNewlinesToBreaks(itemData.ncrRequestReason)"></div>
      </div>
      <div v-if="itemData.orderApproval" class="mt-1 mb-2">
        <strong>NCR Approval</strong>
        <div class="my-1">
          <LabelBadge :labelClass="`label-approval-${itemData.orderApproval.approvalStatus}`">{{itemData.orderApproval.approvalStatus | formatLookupName(ApprovalTypeLookup)}}</LabelBadge>
        </div>
        <strong class="mt-1">Items</strong>
        <div class="my-1">
          <div v-if="itemData.orderApproval.approvalStatus == ApprovalTypes.denied && itemData.orderApproval.rejectedQuantity > 0">
            <i class="far fa-times-circle status-denied mr-2"></i>{{itemData.orderApproval.rejectedQuantity}} Rejected Item{{itemData.orderApproval.rejectedQuantity | displayCountPlural}}
          </div>
          <div v-if="itemData.orderApproval.approvalStatus == ApprovalTypes.pending">
            {{itemData.quantity}} Item{{itemData.quantity | displayCountPlural}}
          </div>
          <div v-if="approvedQuantity > 0">
            <i class="far fa-check-circle status-approved mr-2"></i>{{approvedQuantity}} Approved Item{{approvedQuantity | displayCountPlural}}
          </div>
        </div>
      </div>
      <strong class="mt-1">Labels</strong>
      <LabelTags :labelList="itemData.ncrLabelList"  class="mb-2" />
    </div>
  </Popover>
</template>

<script>
import _ from 'lodash'
import Popover from '@/components/popover.vue'
import { ApprovalTypes, ApprovalTypeLookup } from '@/store/types'

export default {
  name: 'OrderItemNCRPopover',
  components: {
    Popover
  },
  props: {
    item: {
      type: Object,
      default: () => { return {} }
    }
  },
  computed: {
    approvedQuantity() {
      if(this.itemData.orderApproval && this.itemData.orderApproval.approvalStatus == ApprovalTypes.approved)
        return this.itemData.quantity
      if(this.itemData.orderApproval && this.itemData.orderApproval.approvalStatus == ApprovalTypes.denied)
        return this.itemData.quantity - this.itemData.orderApproval.rejectedQuantity
      return 0
    }
  },
  watch: {
    item: function(newVal) {
      this.itemData = newVal
    }
  },
  data() {
    return {
      itemData: this.$props.item
    }
  },
  created() {
    this.ApprovalTypes = ApprovalTypes
    this.ApprovalTypeLookup = ApprovalTypeLookup
  },
  methods: {
    displayFromElement(element) {
      this.$refs.ncrPopover.displayFromElement(element)
    }
  }
}
</script>